/* Klaviyo client subscriptions API signup, loaded only when the section has a Klaviyo public key. Single opt-in. */

(function () {
  function initSignup(form) {
    if (!form || form.dataset.bfnBound === '1') return;
    form.dataset.bfnBound = '1';

    var companyId = form.getAttribute('data-bfn-company');
    var listId = form.getAttribute('data-bfn-list');
    var revision = form.getAttribute('data-bfn-revision');
    if (!companyId || !listId) return;

    var message = form.querySelector('[data-bfn-msg]');
    var input = form.querySelector('input[type="email"]');
    var honeypot = form.querySelector('input[name="website"]');
    var submit = form.querySelector('button[type="submit"]');
    var submitting = false;

    function report(text, isError) {
      if (!message) return;
      message.textContent = text;
      message.hidden = false;
      message.setAttribute('role', isError ? 'alert' : 'status');
      message.classList.toggle('bronte-footer__message--error', !!isError);
      if (input) {
        if (isError) {
          input.setAttribute('aria-invalid', 'true');
        } else {
          input.removeAttribute('aria-invalid');
        }
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submitting) return;
      if (!input) return;

      // Honeypot filled means a bot. Show the success message and send nothing.
      if (honeypot && honeypot.value) {
        form.reset();
        report(form.getAttribute('data-bfn-success') || '', false);
        return;
      }

      if (!input.checkValidity()) {
        input.reportValidity();
        return;
      }

      var email = (input.value || '').trim();
      if (!email) return;

      submitting = true;
      if (submit) submit.disabled = true;

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.getAttribute('data-bfn-source') || 'footer',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: listId } } },
        },
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: revision },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          if (response && response.status >= 200 && response.status < 300) {
            form.reset();
            report(form.getAttribute('data-bfn-success') || '', false);
          } else {
            report(form.getAttribute('data-bfn-error') || '', true);
          }
        })
        .catch(function () {
          report(form.getAttribute('data-bfn-error') || '', true);
        })
        .then(function () {
          submitting = false;
          if (submit) submit.disabled = false;
        });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bfn-form]').forEach(initSignup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
